import {Injectable} from '@angular/core';
import {UserService} from "../core/user/user.service";

export interface IQuestionHistory {
  s: string,
  t: number,
  o?: string,
  ct?: string
}

export interface ISkynetShieldInfo {
  userId: string;
  questions: Record<string, IQuestionHistory[]>;
}

const defaultSkynetShieldInfo: ISkynetShieldInfo = {
  userId: null,
  questions: {}
}


@Injectable({
  providedIn: 'root'
})
export class SkynetShieldService {

  allQuestionsHistory: ISkynetShieldInfo = defaultSkynetShieldInfo;

  constructor(
    private _userService: UserService,
  ) {
  }

  public updateQuestionHistory(
    questionKey: string,
    history: IQuestionHistory[]) {

    this.allQuestionsHistory.userId = this._userService.user.id;
    this.allQuestionsHistory.questions[questionKey] = history;

  }


}
